<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>青海省特色生物资源</el-breadcrumb-item>
      <el-breadcrumb-item>专利管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 卡片视图 -->
    <el-card>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-select v-model="queryParams.ptClass" placeholder="选择所属分类" @change="getDataList">
            <el-option-group label="枸杞">
              <el-option label="种质资源" value="501"></el-option>
              <el-option label="栽种采收" value="502"></el-option>
              <el-option label="初级加工" value="503"></el-option>
              <el-option label="精深加工工艺" value="504"></el-option>
              <el-option label="产品开发" value="505"></el-option>
            </el-option-group>
            <el-option-group label="沙棘">
              <el-option label="种质资源" value="506"></el-option>
              <el-option label="栽种采收" value="507"></el-option>
              <el-option label="初级加工" value="508"></el-option>
              <el-option label="精深加工工艺" value="509"></el-option>
              <el-option label="产品开发" value="510"></el-option>
            </el-option-group>
            <el-option-group label="蕨麻">
              <el-option label="种质资源" value="511"></el-option>
              <el-option label="栽种采收" value="512"></el-option>
              <el-option label="初级加工" value="513"></el-option>
              <el-option label="精深加工工艺" value="514"></el-option>
              <el-option label="产品开发" value="515"></el-option>
            </el-option-group>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="请输入申请号"
            v-model="queryParams.appno"
            clearable
            @clear="getDataList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getDataList"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="16">
        </el-col>
      </el-row>


      <!-- 表格数据 -->
      <el-table :data="patentInfoList" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="语言类型" prop="ptLang" width="80px">
          <template slot-scope="scope">
            <span v-if="scope.row.ptLang == 0">中文</span>
            <span v-else>外文</span>
          </template>
        </el-table-column>
        <el-table-column label="专利类型" prop="patType" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.patType == 1">发明专利</span>
            <span v-else-if="scope.row.patType == 2">实用新型</span>
            <span v-else>外观设计</span>
          </template>
        </el-table-column>
        <el-table-column label="申请号" prop="appNumber" width="160px"></el-table-column>
        <el-table-column label="公开号" prop="pubNumber" width="160px"></el-table-column>
        <el-table-column label="标题" prop="title"></el-table-column>
        <el-table-column label="创建时间" prop="createTime" width="160px"></el-table-column>
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="详情"
              placement="top"
              :enterable="false"
            >
              <el-button
                type="primary"
                icon="el-icon-warning-outline"
                size="mini"
                @click="getPatentDetail(scope.row.id)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
              :enterable="false"
            >
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="removeById(scope.row.id)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>


      <!-- 分页组件 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryParams.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 专利详情页面 -->
    <el-dialog :title="'专利详情：' + showDetailTitle" :visible.sync="showPatentDetailDialog" v-if="showPatentDetailDialog"
      width="900px">
      <v-pt-detail :data="currentDetailPatent"></v-pt-detail>
    </el-dialog>
  </div>
</template>

<script>
import vPtDetail from '../../search/PtDetail.vue'
export default {
  components: {
    vPtDetail
  },
  data() {
    return {
      showPatentDetailDialog: false,
      queryParams: {
        ptClass: "",
        appno: "",
        pageNo: 1,
        pageSize: 10,
        mtype: 50
      },
      total: 0,
      patentInfoList: [],
      currentDetailPatent: {},
      showDetailTitle: '',
    }
  },
  created() {
    
  },
  methods: {
    handleSizeChange(newSize) {
      this.queryParams.pageSize = newSize;
      this.getDataList();
    },
    handleCurrentChange(newPage) {
      this.queryParams.pageNo = newPage;
      this.getDataList();
    },
    async getDataList() {
      const { data: res } = await this.$http.get("patent/find/inpage", {
        params: this.queryParams
      });
      if (res.code == 0) {
        this.patentInfoList = res.data.list;
        this.total = res.data.total;
      } else {
        this.$message.error(res.msg);
      }
    },
    async removeById(id) {
      const confirmResult = await this.$confirm("是否确认删除该记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$http.delete("patent/remove/"+ 50 +"/" + id);
      if (res.code == 0) {
        this.$message.success("删除成功！");
        this.getDataList();
      } else {
        return this.$message.error("删除失败！");
      }
    },
    async getPatentDetail(id) {
      const { data: res } = await this.$http.get("patent/find/detail/"+ 50 +"/" + id);
      if (res.code == 0) {
        this.showDetailTitle = res.data.ptName;
        this.currentDetailPatent = {
          lg: 1,
          baseInfo: res.data,
          detail: res.data,
          mgr: true
        };
        this.showPatentDetailDialog = true;
      } else {
        this.$message.error(res.msg);
      }
    },
  }
}
</script>

<style lang="less" scoped>

</style>